jQuery(function ($) {
    $('a[href^="#popup-"]').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        $('body').addClass('popup-shown');
        $($(this).attr('href')).css({display: 'flex'});
    });
    $('[id^="popup-"] .close').click(function (e) {
        e.preventDefault();

        $('body').removeClass('popup-shown');
        $(this).closest('[id^="popup-"]').css({display: 'none'});
    });
    $('[id^="popup-"]').click(function(event) {
        let $target = $(event.target);
        if(!$target.closest('.inner').length &&
            $(this).is(":visible")) {
            $('body').removeClass('popup-shown');
            $(this).css({display: 'none'});
        }
    });
});